import React from "react";
import * as DIAG from "storm-react-diagrams";
import LinkView from "./LinkView";

export default class LinkFactory extends DIAG.LinkWidgetFactory {
    /**
	 * Normal link factory
	 * @module LinkFactory
     */
	constructor() {
		super("default");
	}

    /**
	 * Generator
     * @param diagramEngine DiagramEngine instance for current diagram
     * @param link Link model
     * @returns {Object} React element
     */
	generateReactWidget(diagramEngine, link) {
		return React.createElement(LinkView, {
			link: link,
			diagramEngine: diagramEngine,
			color: "var(--blue)",
			width: 3,
			smooth: false
		});
	}
}
